export function isLocalTestSimulationEnabled(
  searchParams,
  environment
) {
  return (
    environment === 'development' &&
    searchParams?.get('localTestSimulation') === '1'
  );
}
